import { render, staticRenderFns } from "./Corse.vue?vue&type=template&id=74177513&scoped=true"
import script from "./Corse.vue?vue&type=script&lang=js"
export * from "./Corse.vue?vue&type=script&lang=js"
import style0 from "./Corse.vue?vue&type=style&index=0&id=74177513&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74177513",
  null
  
)

export default component.exports